module.exports = __webpack_public_path__ + "static/media/garab-dai.db8e5c8b.jpg";